(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-clusters"] && !Shopify.designMode) return;
  try {
    
(function() {
  function refreshFlickity(wrap) {
    var slider = wrap.closest('[data-theme-slider]');
    if (!slider || !window.Flickity) return;
    var flick = window.Flickity.data(slider);
    if (flick && flick.resize) flick.resize();
  }

  function initWrap(wrap) {
    if (wrap.dataset.tdInit === '1') return;
    wrap.dataset.tdInit = '1';

    var clampLines = parseInt(wrap.getAttribute('data-clamp-lines'), 10);
    if (!clampLines || clampLines <= 0) return;
    wrap.style.setProperty('--clamp-lines', clampLines);

    var quote = wrap.querySelector('.td-card__quote');
    var toggle = wrap.querySelector('.td-card__toggle');
    if (!quote || !toggle) return;

    function check() {
      if (wrap.classList.contains('is-expanded')) return;
      var overflows = quote.scrollHeight - quote.clientHeight > 1;
      if (overflows) {
        toggle.hidden = false;
        toggle.textContent = toggle.getAttribute('data-more-text');
      } else {
        toggle.hidden = true;
      }
    }

    toggle.addEventListener('click', function() {
      var expanded = wrap.classList.toggle('is-expanded');
      toggle.textContent = expanded
        ? toggle.getAttribute('data-less-text')
        : toggle.getAttribute('data-more-text');
      refreshFlickity(wrap);
    });

    check();
    var resizeTimer;
    window.addEventListener('resize', function() {
      if (wrap.classList.contains('is-expanded')) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(check, 200);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.td-card__quote-wrap').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-dynamic"] && !Shopify.designMode) return;
  try {
    
(function() {
  function refreshFlickity(wrap) {
    var slider = wrap.closest('[data-theme-slider]');
    if (!slider || !window.Flickity) return;
    var flick = window.Flickity.data(slider);
    if (flick && flick.resize) flick.resize();
  }

  function initWrap(wrap) {
    if (wrap.dataset.tdInit === '1') return;
    wrap.dataset.tdInit = '1';

    var clampLines = parseInt(wrap.getAttribute('data-clamp-lines'), 10);
    if (!clampLines || clampLines <= 0) return;
    wrap.style.setProperty('--clamp-lines', clampLines);

    var quote = wrap.querySelector('.td-card__quote');
    var toggle = wrap.querySelector('.td-card__toggle');
    if (!quote || !toggle) return;

    function check() {
      if (wrap.classList.contains('is-expanded')) return;
      var overflows = quote.scrollHeight - quote.clientHeight > 1;
      if (overflows) {
        toggle.hidden = false;
        toggle.textContent = toggle.getAttribute('data-more-text');
      } else {
        toggle.hidden = true;
      }
    }

    toggle.addEventListener('click', function() {
      var expanded = wrap.classList.toggle('is-expanded');
      toggle.textContent = expanded
        ? toggle.getAttribute('data-less-text')
        : toggle.getAttribute('data-more-text');
      refreshFlickity(wrap);
    });

    check();
    var resizeTimer;
    window.addEventListener('resize', function() {
      if (wrap.classList.contains('is-expanded')) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(check, 200);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.td-card__quote-wrap').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
